module.exports = __webpack_public_path__ + "img/sortImg1-1.606e9535.png";